import { useEffect, useState } from 'react';
import api from '../../api/axios';
const StatCard = ({ title, value, color }) => (
    <div className={`p-6 rounded-lg shadow ${color}`}>
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-3xl font-bold">{value}</p>
    </div>
);
const SuperAdminDashboard = () => {
    const [stats, setStats] = useState(null);
    useEffect(() => {
        api.get('/super_admin/dashboard_stats').then(res => setStats(res.data));
    }, []);
    return (
        <div className="p-6">
            <h1 className="text-3xl font-bold mb-6">Super Admin Dashboard</h1>
            {stats ? (
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    <StatCard title="Total Revenue" value={`₹${stats.total_revenue}`} color="bg-green-100" />
                    <StatCard title="Businesses" value={stats.total_businesses} color="bg-blue-100" />
                    <StatCard title="Profiles" value={stats.total_profiles} color="bg-indigo-100" />
                    <StatCard title="Users" value={stats.total_users} color="bg-yellow-100" />
                    <StatCard title="Admins (Sevaks)" value={stats.total_admins} color="bg-purple-100" />
                </div>
            ) : <p>Loading stats...</p>}
        </div>
    );
};
export default SuperAdminDashboard;